import useResources from "./use-resources";

export interface PropertyPhoto {
  id: number;
  src: string;
  position: number;
  is_main: boolean;
}

export default function usePropertyPhotos(
  propertyId: number | undefined,
  isFolder = false,
) {
  const rootPath = propertyId
    ? isFolder
      ? `property-folders/${propertyId}/photos`
      : `biens/${propertyId}/photos`
    : null;

  const {
    resources: photos,
    error,
    isLoading,
    mutate,
    axios,
    batchCreate: createPhotos,
    reorder: reorderPhotos,
  } = useResources<PropertyPhoto>(rootPath);

  async function deletePhoto(photoId: number) {
    await axios.delete(`${rootPath}/${photoId}`);
    mutate((current) => current?.filter((p) => p.id !== photoId), {
      revalidate: false,
    });
  }

  async function setMainPhoto(photoId: number) {
    const res = await axios.put(`${rootPath}/${photoId}/set-main`);
    mutate(
      (current) =>
        current?.map((p) => ({
          ...p,
          is_main: p.id === photoId,
        })),
      { revalidate: false },
    );
    return res.data;
  }

  return {
    photos,
    photosOrder: photos.map((photo) => photo.id),
    error,
    isLoading,
    mutate,
    createPhotos,
    deletePhoto,
    reorderPhotos,
    setMainPhoto,
  };
}
